import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "crop-component" }
const _hoisted_2 = { class: "crop-image" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "crop" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "actions" }

import { ref, nextTick, onBeforeUnmount, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";

import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'crop-image',
  props: {
    aspectRatio: {},
    viewMode: { default: 1 }
  },
  emits: ["change", "cancel"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const fileInput = ref();

const cropper = ref<Cropper | null>(null);
const imageUrl = ref<string | null>(null);
const imageElement = ref<HTMLImageElement | null>(null);

function fileSelect(event: any) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      imageUrl.value = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }
}

function cropImage() {
  if (cropper.value) {
    cropper.value.getCroppedCanvas().toBlob((blob) => {
      if (blob) {
        const reader = new FileReader();
        reader.onloadend = () => {
          emit("change", reader.result);
          imageUrl.value = null;
          fileInput.value.value = "";
        };
        reader.readAsDataURL(blob);
      }
    });
  }
}

function cropImageCancel() {
  imageUrl.value = null;
  fileInput.value.value = "";
  emit("cancel");
}

watch(
  () => imageUrl.value,
  async () => {
    await nextTick(async () => {
      if (imageUrl.value) {
        if (cropper.value) cropper.value.destroy();

        await nextTick(() => {
          if (imageElement.value) {
            cropper.value = new Cropper(imageElement.value, {
              aspectRatio: props.aspectRatio ?? NaN,
              viewMode: props.viewMode,
            });
          }
        });
      }
    });
  },
);

onBeforeUnmount(() => {
  if (cropper.value) {
    cropper.value.destroy();
  }
});

onMounted(async () => {
  await nextTick(async () => {
    if (fileInput.value) {
      fileInput.value.click();
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (imageUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                ref_key: "imageElement",
                ref: imageElement,
                src: imageUrl.value,
                alt: "Source Image"
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-default",
            onClick: cropImage
          }, _toDisplayString(_unref(t)("common.labels.save")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-default",
            onClick: cropImageCancel
          }, _toDisplayString(_unref(t)("common.labels.cancel")), 1)
        ])
      ])
    ]),
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      onChange: fileSelect,
      accept: "image/*"
    }, null, 544)
  ]))
}
}

})